import '../../css/app.css'
import '../../css/main.css'
import '../../css/common.css'
import '../../css/payment.css'
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

function SearchDate({
    type,
    inputRef,
    setDateRange,
    preDate,     // 부모로부터 넘어옴
    nextDate,    // 부모로부터 넘어옴
    isDisabled = false,
    state = true
}) {
    // "당일" 버튼
    const handleTodayClick = () => {
        const today = dayjs().format('YYYY/MM/DD');
        setDateRange(today, today);
    };

    // "전일" 버튼 (클릭 시 마다 하루씩 과거로 이동)
    const handleYesterdayClick = () => {
        const newStart = dayjs(preDate, 'YYYY/MM/DD')
            .subtract(1, 'day')
            .format('YYYY/MM/DD');
        const newEnd = dayjs(nextDate, 'YYYY/MM/DD')
            .subtract(1, 'day')
            .format('YYYY/MM/DD');
        setDateRange(newStart, newEnd);
    };

    // "당월" 버튼 (매번 누르면 당월로 초기화)
    const handleThisMonthClick = () => {
        const startOfMonth = dayjs().startOf('month').format('YYYY/MM/DD');
        const today = dayjs().format('YYYY/MM/DD');
        setDateRange(startOfMonth, today);
    };

    // "전월" 버튼 (클릭 시 마다 전달로 한 달씩 과거 이동)
    // - 계속 눌렀을 때 계속 전달로 이동하려면, 현재 preDate와 nextDate를 기준으로 -1month
    const handleLastMonthClick = () => {
        // 현재 preDate 기준으로 "이달 1일"을 구한 뒤, 거기서 한 달 전
        const startOfLastMonth = dayjs(preDate, 'YYYY/MM/DD')
            .startOf('month')     // preDate가 4/22여도 여기서 4/01로 이동
            .subtract(1, 'month'); // => 3/01

        // startOfLastMonth(=3/01)의 그 달 말일 = 3/31
        const endOfLastMonth = startOfLastMonth.endOf('month');

        setDateRange(
            startOfLastMonth.format('YYYY/MM/DD'),
            endOfLastMonth.format('YYYY/MM/DD')
        );
    };

    return (
        <div className="input_row" style={{ fontSize: "12px" }}>
            <div className="input_wrap">
                <div className="input_item" style={{ display: "flex", gap: "10px" }}>
                    {state && (
                        <div
                            className="sorting"
                            style={{
                                position: "relative",
                                height: "100%",
                                marginTop: 0,
                                pointerEvents: isDisabled ? "none" : "auto",
                                opacity: isDisabled ? 0.5 : 1
                            }}
                        >
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleTodayClick}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleYesterdayClick}
                            >
                                전일
                            </button>
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleThisMonthClick}
                            >
                                당월
                            </button>
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleLastMonthClick}
                            >
                                전월
                            </button>
                        </div>
                    )}

                    <input
                        ref={inputRef}
                        className="datepicker form-control"
                        style={{
                            height: "30px",
                            width: "185px",
                            backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? "not-allowed" : "text"
                        }}
                        id="datepicker1"
                        name="datepicker1"
                        type="text"
                        disabled={isDisabled}
                        placeholder="날짜 범위를 선택하세요"
                    />
                </div>
            </div>
        </div>
    );
}

function SearchDateMonth({
    type,
    inputRef,
    setDateRange,
    preDate,     // 부모로부터 넘어옴
    nextDate,    // 부모로부터 넘어옴
    isDisabled = false,
    state = true
}) {
    // "당월" 버튼 (매번 누르면 당월로 초기화)
    const handleThisMonthClick = () => {
        const startOfMonth = dayjs().startOf('month').format('YYYY/MM/DD');
        const today = dayjs().format('YYYY/MM/DD');
        setDateRange(startOfMonth, today);
    };

    // "전월" 버튼 (클릭 시 마다 전달로 한 달씩 과거 이동)
    // - 계속 눌렀을 때 계속 전달로 이동하려면, 현재 preDate와 nextDate를 기준으로 -1month
    const handleLastMonthClick = () => {
        // 현재 preDate 기준으로 "이달 1일"을 구한 뒤, 거기서 한 달 전
        const startOfLastMonth = dayjs(preDate, 'YYYY/MM/DD')
            .startOf('month')     // preDate가 4/22여도 여기서 4/01로 이동
            .subtract(1, 'month'); // => 3/01

        // startOfLastMonth(=3/01)의 그 달 말일 = 3/31
        const endOfLastMonth = startOfLastMonth.endOf('month');

        setDateRange(
            startOfLastMonth.format('YYYY/MM/DD'),
            endOfLastMonth.format('YYYY/MM/DD')
        );
    };

    return (
        <div className="input_row" style={{ fontSize: "12px" }}>
            <div className="input_wrap">
                <div className="input_item" style={{ display: "flex", gap: "10px" }}>
                    {state && (
                        <div
                            className="sorting"
                            style={{
                                position: "relative",
                                height: "100%",
                                marginTop: 0,
                                pointerEvents: isDisabled ? "none" : "auto",
                                opacity: isDisabled ? 0.5 : 1
                            }}
                        >
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleThisMonthClick}
                            >
                                당월
                            </button>
                            <button
                                type="button"
                                className="btn searchPayBtn"
                                style={{ height: "30px" }}
                                onClick={handleLastMonthClick}
                            >
                                전월
                            </button>
                        </div>
                    )}

                    <input
                        ref={inputRef}
                        className="datepicker form-control"
                        style={{
                            height: "30px",
                            width: "185px",
                            backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? "not-allowed" : "text"
                        }}
                        id="datepicker1"
                        name="datepicker1"
                        type="text"
                        disabled={isDisabled}
                        placeholder="날짜 범위를 선택하세요"
                    />
                </div>
            </div>
        </div>
    );
}

function SearchSelectText({ type, selectData, handleSelectChange, selectedValue, handleSelectTextChange, selectedText }) {
    return (
        <div className="input_row">
            <label>{type}</label>
            <div className="input_wrap">
                <div className="input_item flex">
                    <select id="check_gubun" name="check_gubun" className="form-select" aria-label="Default select example"
                        onChange={handleSelectChange} value={selectedValue}>
                        {
                            selectData.map(function (a, i) {
                                return (
                                    <option value={a}>{a}</option>
                                )
                            })
                        }
                    </select>
                    <input id="level_info" type="text" className="form-control" placeholder="영업자명을 정확하게 입력해주십시오" maxlength="60" disabled="" value={selectedText} onChange={handleSelectTextChange} />
                </div>
            </div>
        </div>
    )
}

function SearchSelect({ type, selectData, handleSelectChange, selectedValue }) {
    return (
        <div className="input_row flex">
            <label>{type}</label>
            <div className="input_wrap">
                <div className="input_item">
                    <select id="select_status" className="form-select" onChange={handleSelectChange} value={selectedValue}>
                        {
                            selectData.map(function (a, i) {
                                return (
                                    <option value={a}>{a}</option>
                                )
                            })
                        }
                    </select>
                </div>
            </div>
        </div>
    )
}

function SearchRange({ type, preRange, handlePreRange, nextRange, handleNextRange }) {
    return (
        <div className="input_row flex amt_range">
            <label>{type}</label>
            <div className="input_wrap">
                <div className="input_item" style={{ display: "flex" }}>
                    <input id="start_amt" type="text" className="form-control" placeholder="0" maxlength={7} value={preRange} onChange={handlePreRange} />
                    <span style={{ margin: "0.5rem" }}> ~ </span>
                    <input id="end_amt" type="text" className="form-control" placeholder="0" maxlength={7} value={nextRange} onChange={handleNextRange} />
                </div>
            </div>
        </div>
    )
}

function SearchInput({ type, selectedText, handleSelectTextChange }) {
    return (
        <div class="input_row">
            <label>{type}</label>
            <div class="input_wrap">
                <div class="input_item flex">
                    <input id="search_value" type="text" className="form-control" placeholder="입력해주세요" maxlength="60" disabled="" value={selectedText} onChange={handleSelectTextChange} />
                </div>
            </div>
        </div>
    )
}

function SearchInputBtn({ type, selectedText, handleSelectTextChange, onClick }) {
    return (
        <div class="input_row">
            <label>{type}</label>
            <div class="input_wrap">
                <div class="input_item flex">
                    <input id="search_value" type="text" className="form-control" placeholder="입력해주세요" maxlength="60" disabled="" value={selectedText} onChange={handleSelectTextChange} />
                    <button onClick={onClick} id="tabulator-html-filter-go" type="button" class="btn btn-primary">검색</button>
                </div>
            </div>
        </div>
    )
}

function SearchBtn({ type, onClick }) {
    return (
        <div className="button_wrap">
            <button onClick={onClick} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn">{type}</button>
        </div>
    )
}

function SearchCrteateBtn({ type, onClick }) {
    return (
        <button type="button" class="btn btn-primary modal_btn btn_small" onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" data-lucide="plus" class="lucide lucide-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            {type}
        </button>
    )
}

function SearchExcelBtn({ type }) {
    return (
        <button type="button" class="btn btn-primary on-pc" id="dist_excel_down" aria-expanded="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="download" data-lucide="download" class="lucide lucide-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
            {type}
        </button>
    )
}

export { SearchDate, SearchDateMonth, SearchSelectText, SearchSelect, SearchRange, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn, SearchInput }